<template>
    <div>
        <!-- Modal Liberação de Laudo -->
        <div class="modal fade" id="liberaLaudoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="marcacao">
                    <div class="modal-header">
                        <h5 class="modal-title">Resultados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card" v-if="marcacao">
                            <div class="card-body py-2">
                                <celula-dados-paciente :hor="marcacao" />
                                <div>#{{ id_atendimento }}</div>
                            </div>
                        </div>
                        
                        <az-empty-state v-if="!dados" />

                        <template v-else>
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th width="3%"></th>
                                        <th width="27%">Procedimento</th>
                                        <th width="10%">
                                            <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-outline-secondary" @click="selecionar_view('L')">
                                                    <i class="far fa-file-alt"></i>
                                                </button>
                                                <button type="button" class="btn btn-outline-secondary" @click="selecionar_view('C')">
                                                    <i class="fas fa-list-ol"></i>
                                                </button>
                                                <button type="button" class="btn btn-outline-secondary" @click="selecionar_view('N')">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </th>
                                        <th width="60%">Resultado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(laudo, ilx) in dados" :key="ilx" :class="laudo.st_layout_impressao ? '' : 'table-secondary'">
                                        <td>
                                            <az-input 
                                                type="checkbox"
                                                :edicao="laudo.st_layout_impressao ? true : false"
                                                v-model="laudo.selecionado" />
                                        </td>
                                        <td>
                                            <span class="badge badge-secondary mr-1" v-if="laudo.atendimento_procedimento.procedimento.st_sigla">
                                                {{ laudo.atendimento_procedimento.procedimento.st_sigla }}
                                            </span>
                                            {{ laudo.atendimento_procedimento.procedimento.search }}
                                            <div>
                                                <span class="badge" :class="'badge-' + laudo.status_laudo.st_color">
                                                    {{ laudo.status_laudo.search }}
                                                </span>

                                                <a href="#" class="card-link ml-2" v-if="laudo.selecionado" @click.prevent="laudo.tem_obs = !laudo.tem_obs">
                                                    <i class="fa fa-comment" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                            <template v-if="laudo.selecionado && laudo.tem_obs">
                                                <az-input
                                                    sizing="sm"
                                                    label="Observação para o laudo"
                                                    type="textarea"
                                                    rows="3"
                                                    placeholder="Informar..."
                                                    v-model="laudo.st_result_obs" />
                                            </template>
                                            <div class="alert alert-info p-2 small mt-1" v-else-if="laudo.st_result_obs">
                                                {{ laudo.st_result_obs }}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="btn-group btn-group-sm" role="group" aria-label="Basic example" v-if="laudo.st_layout_impressao">
                                                <button type="button" class="btn" :class="laudo.view == 'L' ? 'btn-secondary' : 'btn-outline-secondary'" @click="laudo.view = 'L'">
                                                    <i class="far fa-file-alt"></i>
                                                </button>
                                                <button type="button" class="btn" :class="laudo.view == 'C' ? 'btn-secondary' : 'btn-outline-secondary'" @click="laudo.view = 'C'">
                                                    <i class="fas fa-list-ol"></i>
                                                </button>
                                                <button type="button" class="btn" :class="laudo.view == 'N' ? 'btn-secondary' : 'btn-outline-secondary'" @click="laudo.view = 'N'">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </td>
                                        <td>
                                            <template v-if="laudo.st_layout_impressao">
                                                <span v-html="laudo.st_layout_impressao" v-if="laudo.view == 'L'"></span>
                                                <div v-if="laudo.view == 'C'">
                                                    <table class="table table-sm">
                                                        <tr v-for="(campo, icx) in laudo.dados" :key="icx">
                                                            <td>
                                                                {{ campo.label }}
                                                            </td>
                                                            <td>
                                                                {{ campo.value }}
                                                                <span class="small text-muted" v-if="campo.um">
                                                                    {{ campo.um }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </template>
                                            
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            
                            <pre v-if="false">{{ dados }}</pre>
                            <pre v-if="false">{{ fila }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        
                        <template v-if="fila && fila.lista_status">
                            <az-submit 
                                v-for="(status, isx) in fila.lista_status" 
                                :key="isx" 
                                :color="status.st_color" 
                                :disabled="!lista_selecionado.length" 
                                @click="atualizar_status(status)">
                                {{ status.st_acao }}
                            </az-submit>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";

export default {
    data() { 
        return { 
            dados: null, 
            validade: false, 
            marcacao: null, 
            id_atendimento: null, 
        }
    },

    props: ['fila'],

    components: { 
        AzEmptyState, 
        AzSubmit,
        AzInput, 
        CelulaDadosPaciente, 
    }, 

    computed: { 
        lista_selecionado: function () { 
            if ( !this.dados )
                return [];

            return this.dados.filter(item => item.selecionado);
        }
    },

    methods: { 
        selecionar_view (tipo) { 
            this.dados.forEach(item => { 
                item.view = tipo;
            });
        },

        abrir (id_atendimento, marcacao) { 
            this.id_atendimento = id_atendimento;
            this.marcacao = _.cloneDeep(marcacao);
            this.dados = null;
            this.validade = false; 

            $('#liberaLaudoModal').modal('show');

            this.$util.load(this, { 
                service: 'laudos',
                func: 'lista_laboratorio',
                parms: { 
                    id_atendimento: id_atendimento, 
                },
                loadTo: res => { 
                    this.dados = res.laudos.map(item => { 
                        item.view = 'L';
                        item.selecionado = false;
                        item.tem_obs = item.st_result_obs ? true : false;

                        return item;
                    });
                }
            });
        },

        atualizar_status (status) { 

            if ( !this.lista_selecionado.length ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Nenhum laudo selecionado.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, {
                service: 'laudos',
                func: 'status',
                dados: {
                    id_laudo: this.dados[0].id_laudo,
                    id_status_laudo: status.id_status_laudo,
                    fila: this.fila ? this.fila.id_fila_laudo : null,
                    lista: this.lista_selecionado.map(item => item.id_laudo),
                    obss: this.lista_selecionado.map(item => { 
                        return { 
                            id_laudo: item.id_laudo, 
                            st_result_obs: item.st_result_obs, 
                        };
                    }), 
                },
                toast: true,
                modal: 'liberaLaudoModal',
                callback: res => {
                    if ( res == 'OK' || res.id_status_laudo ) {
                        this.$emit('refresh');
                    }
                }
            });

        }
    }
}
</script>

<style scoped>
.modal-dialog-total {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>
